import { canvassesGateway } from "@/gateways/canvassesGateway";
import { useQuery } from "@tanstack/vue-query";

export function useFindCanvassByShortUrlId(shortUrlId: string) {
  const query = useQuery({
    queryKey: ["canvass", shortUrlId],
    queryFn: () => canvassesGateway.findCanvassByShortUrlId(shortUrlId),
  });

  return {
    ...query,
    findCanvassStatus: query.status,
    canvass: query.data,
  };
}
